import { Fragment, useEffect } from 'react'
import { motion } from 'motion/react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link, useLocation } from 'react-router-dom'
import animationVariants from '../../lib/animationVariants'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css/bundle'

export default function Person ({ data }) {
  const location = useLocation()
  const { direction } = location.state || {}

  useEffect(() => {
    if (location.state) {
      location.state.background = '#000'
    } else {
      location.state = {
        background: '#000'
      }
    }
  }, [location])

  return (
    <motion.div className='w-100 h-100' variants={animationVariants[direction]} initial='hidden' animate='visible' exit='exit'>
      <Container fluid className='w-100 h-100'>
        <Row as='section' id='person' className='h-100'>
          <Col xl={4} className='d-flex justify-content-center align-items-center px-3 left'>
            <Swiper navigation pagination modules={[Navigation, Pagination]} className='w-100'>
              {data.images.map((img, i) => (
                <SwiperSlide key={`swiper-slide-${i}`}>
                  <div className='slide-container px-5 pt-3'>
                    <img src={`/images/${img.src}`} alt='' className='img-fluid pb-3' style={{ maxHeight: 600 }} />

                    {img.caption && (
                      <div className='caption text-center pb-4'>
                        <span className='d-inline-block pb-2'>{img.caption}</span>
                      </div>
                    )}
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Col>
          <Col className='right'>
            <Row>
              <Col xl={12} xxl={9}>
                {data.headings.map((heading, i) => (
                  <div className='heading' key={`person-heading-${i}`}>
                    <div className='name'>{heading.content}</div>
                    <div className='dates'>
                      <em>{heading.sub}</em>
                    </div>
                  </div>
                ))}
                <div className='content mb-4'>
                  {data.introduction.map((intro, i) => (
                    <p key={`person-intro-${i}`}>
                      <em>{intro.content}</em>
                    </p>
                  ))}
                  {data.main.map((main, i) => (
                    <p key={`person-main-${i}`}>{main.content}</p>
                  ))}
                </div>
              </Col>
              <Col xl={12} xxl={3}>
                {data.parents && (
                  <>
                    <h6>Parents</h6>
                    <ul className='list-unstyled'>
                      {data.parents.map((parent, i) => (
                        <Fragment key={`person-parent-${i}`}>
                          <li>
                            {parent.href ? <Link to={parent.href} state={{ direction: parent.href.includes('ames-family-at-work') ? 'left' : 'default' }}>{parent.label}</Link> : <>{parent.label}</>}
                          </li>
                        </Fragment>
                      ))}
                    </ul>
                  </>
                )}
                {data.spouse && (
                  <>
                    <h6>Spouse</h6>
                    <ul className='list-unstyled'>
                      {data.spouse.map((spouse, i) => (
                        <Fragment key={`person-spouse-${i}`}>
                          <li>
                            {spouse.href ? <Link to={spouse.href} state={{ direction: spouse.href.includes('ames-family-at-work') ? 'left' : 'default' }}>{spouse.label}</Link> : <>{spouse.label}</>}
                          </li>
                        </Fragment>
                      ))}
                    </ul>
                  </>
                )}
                {data.children && (
                  <>
                    <h6>Children</h6>
                    <ul className='list-unstyled'>
                      {data.children.map((child, i) => (
                        <Fragment key={`person-child-${i}`}>
                          <li>
                            {child.href ? <Link to={child.href} state={{ direction: child.href.includes('ames-family-at-work') ? 'left' : 'default' }}>{child.label}</Link> : <>{child.label}</>}
                          </li>
                        </Fragment>
                      ))}
                    </ul>
                  </>
                )}
                {data.stepChildren && (
                  <>
                    <h6>Step Children</h6>
                    <ul className='list-unstyled'>
                      {data.stepChildren.map((child, i) => (
                        <Fragment key={`person-step-child-${i}`}>
                          <li>
                            {child.href ? <Link to={child.href} state={{ direction: child.href.includes('ames-family-at-work') ? 'left' : 'default' }}>{child.label}</Link> : <>{child.label}</>}
                          </li>
                        </Fragment>
                      ))}
                    </ul>
                  </>
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </motion.div>
  )
}
